import React, { useState, useEffect, useContext } from 'react';
import { useParams } from 'react-router-dom';


import Get from '../../api/Get'
import { DOCTORS_BY_SPECIALITY } from "../../api/Routes";
import { authContext } from "../../context/AuthContext";
import LoadingList from "../../loader/LoadingList";
import CardDoctor from '../../components/doctor/CardDoctor';
import FiltroEspecialidad from "../../components/doctor/FiltroEspecialidad"

function SearchDoctor(){
    const {idPaciente} = useParams();
    const [loading, setLoading] = useState(false)
    const [idEspecialidad, setIdEspecialidad] = useState(24)
    const [doctores, setDoctores] = useState([])

    //Token de autentificación para los servicios
    const {auth} = useContext(authContext)
    let accesToken = auth.data.access_token;

    useEffect(() => cargarDoctores(), [idEspecialidad])

    const cargarDoctores = () => {
        const url = `${DOCTORS_BY_SPECIALITY}/${idEspecialidad}`
        
        setLoading(true)

        Get({url: url, access_token: accesToken}).then((resp) => {
            let data = resp.data;
            setDoctores(data)
            setLoading(false)
        })
        .catch((err) => {
            console.log("Error encontrado", err)
            setLoading(false)
        })
    }

    const filterChange = opcion => setIdEspecialidad(opcion.value)

    return (<>
        {loading && LoadingList()}
        <FiltroEspecialidad filterChange={filterChange} />

        <div className='body'>
            {
                doctores.map(doc => (
                   
                    <CardDoctor key={doc?.id} doctorInfo={doc} />
                ))
            }
        </div>
       
    </>)
}

export default SearchDoctor